  var bundles_array = [
  {
    bundle_name: 'Beginner Kit',
    bundle_class: 'Beginner_Kit',
    sold: false,
    bundle_discount: 41.8410042, 
    bundle_components: [
      {id: 32912436428896, price:99.00, replace_variant:32912436461664, replace_price: 99.00}, // FasciaBlaster®
      {id: 32917301756000, price:69.00, replace_variant:32917301788768, replace_price: 69.00}, // FaceBlaster™
      {id: 32917313159264, price:30.00, replace_variant:32917313192032, replace_price: 30.00}, // FasciaBlaster® Nugget 
      {id: 32182654795872, price:22.00}, // Spot KryoPack
      {id: 32669289447520, price:19.00} // ROLL ON BLASTER OIL
    ], free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [{id: 2425380208652, price:9.99}] // Cellulite Myth Book
    }
  },
    {
      bundle_name: 'Silk Set ',
      bundle_class: 'Silk_Set_OS',
      sold: false,
      bundle_discount: 60.3550296, 
      bundle_components: [
      {id: 39563673436256, price: 69.00}, // Silk Pillowcase
      {id: 39563677270112, price: 16.00}, // Scrunchy
      {id: 39563680546912, price: 69.00}, // Silk Turban
      {id: 39559432077408, price:15.00} // Satin cinch Bag
      ]
    },
    {
      bundle_name: 'KryoKit',
      bundle_class: 'KryoKit',
      sold: false,
      bundle_discount: 75.1295337,
      bundle_components: [
        /*
        {id: 32182654795872, price:22.00}, // Ashley Black's Kryopack™ Spot
        {id: 32183246454880, price:34.00}, // Ashley Black's Kryopack™ Eye Wrap
        {id: 32183244062816, price:34.00}, // Ashley Black's Kryopack™ Face Wrap
        {id: 32183192780896, price:46.00}, // Ashley Black's Kryopack™ Back And Abs Wrap
        {id: 32183262675040, price:57.00} // Ashley Black's Kryomat™ Small
        */
        {id: 32700027994208, price:193.00} // Ashley Black's Kryomat™ Small
      ]
    },
    {
      bundle_name: 'Hydrogel Kit',
      bundle_class: 'Hydrogel_Kit',
      sold: false,
      bundle_discount: 65.4545455,
      bundle_components: [
        {id: 39559436730464, price: 29.00}, // Eye Patch Hydrogel (7 pack)
        {id: 39559433781344, price: 29.00}, // Lip Patch Hydrogels (7 pack)
        {id: 39559445119072, price: 29.00}, // Forehead Hydrogel (7 pack)
        {id: 39559441907808, price: 39.00}, // Décolleté Neck Hydrogel
        {id: 39559439941728, price: 39.00} // Hydrogel Jawline Patch (7 pack)
      ]
    },
    {
      bundle_name: 'SAUNA SUIT - Extra Small - Medium',
      bundle_class: 'Sauna_Suit_xs-m',
      sold: false,
      bundle_discount: 61.5384615,
      bundle_components: [
        {id: 39245878558816, price:39.00} // Ashley Black's Kryomat™ Small
      ]
    },
    {
      bundle_name: 'Sauna Suit - Large - Extra Extra Large',
      bundle_class: 'Sauna_Suit_l-xxl',
      sold: false,
      bundle_discount: 61.5384615,
      bundle_components: [
        {id: 39245878591584, price:39.00} // Ashley Black's Kryomat™ Small
      ]
    },
      {
      bundle_name: 'OMGBlaster And Eye Kryowrap',
      bundle_class: 'OMGBlaster_And_Eye_Kryowrap',
      sold: false,
      bundle_discount: 67.75956284153005,
      bundle_components: [
      {id: 39391782371424, price:149.00}, // OMGBlaster
      {id: 32183246454880, price:34.00} // Ashley Black's Kryopack™ Eye Wrap
    ]
    }
    
  ];
  // if id null, select 3 display by most expensive
var bundles_per_handle = {
  //19824951165024: ['Celebrity_Kit', "Onyx_Initiator_Kit", "Platinum_Pack", "Budget_Box", 'Quick_Start_Kit', 'De-Stress_Pack', 'Celebrity_Kit']
};

var bundle_upsell = { /*Beginner_Kit: ["Platinum_Pack", "Back_Pack"]*/};

var subscribtion_products = [
  {variant_id: 32669495459936, name: 'Ashley Black\'s ™ Deluxe Serum', handle:'deluxe-serum', recharge_discount: 18, rc_price: '$48.38'},
  {variant_id: 19825070506080, name: '3.5 OZ AfterBlaster Cream™', handle: 'small-afterblaster-cream', recharge_discount: 7, rc_price: '$17.67'},
  //{variant_id: 19824951165024, name: '3.4 OZ Blaster Oil® Unscented', handle:'roll-on-blaster-oil', recharge_discount: 7, rc_price: '$17.67'},
  {variant_id: 36058796684, name: 'FaceCare Essentials Kit', handle:'facekit-products', recharge_discount: 10, rc_price: '$31.50'},
  {variant_id: 2474685038604, name: '12 OZ Blaster Oil®', handle:'12-oz-blaster-oil', recharge_discount: 10, rc_price: '$37.80'},
  {variant_id: 19824951165024, name: '3.4 OZ Blaster Oil®', handle:'small-oz-blaster-oil', recharge_discount: 7, rc_price: '$17.67'},
  {variant_id: 32669289447520, name: 'Roll On Blaster Oil', handle:'roll-on-blaster-oil', recharge_discount: 7, rc_price: '$17.67'},
  {variant_id: 39559478509664, name: 'Coffee scrub 8 oz', handle:'coffee-scrub-8-oz', recharge_discount: 20, rc_price: '$28.00'},
  {variant_id: 39559445905504, name: 'Lip scrub', handle:'lip-scrub', recharge_discount: 20, rc_price: '$17.60'},
  {variant_id: 39559433191520, name: "Ashley Black's Maximum Lip", handle:'lip-plump', recharge_discount: 20, rc_price: '$17.60'},
  {variant_id: 39559448756320, name: "LINEFIX", handle:'linefix', recharge_discount: 20, rc_price: '$31.20'},
  {variant_id: 39559445119072, name: "Forehead Hydrogel (7 pack)", handle:'forehead-hydrogel-7-pack', recharge_discount: 20, rc_price: '$23.20'},
  {variant_id: 39559436730464, name: "Hydrogel Eye Patch (7 pack)", handle:'eye-patch-hydrogel-7-pack', recharge_discount: 20, rc_price: '$23.20'},
  {variant_id: 39559433781344, name: "Hydrogel Lip Patch (7 pack)", handle:'lip-patch-hydrogels-7-pack', recharge_discount: 20, rc_price: '$23.20'},
  {variant_id: 39559439941728, name: "Hydrogel Jawline Patch (7 pack)", handle:'lifting-patch-for-jaw-7-pack', recharge_discount: 20, rc_price: '$31.20'},
  {variant_id: 39559441907808, name: "Hydrogel Décolleté Patch (7 pack)", handle:'decollete-neck-hydrogel-7-pack', recharge_discount: 20, rc_price: '$31.20'},
  {variant_id: 39559478739040, name: "Shea butter scrub 8 oz", handle:'shea-butter-scrub-8-oz', recharge_discount: 20, rc_price: '$28.00'}
];

var fake_product_name = {
  'pre-kit-platinum-pack': "FasciaBlaster Large Backpack, Extenders, FaceBlaster, FasciaBlaster, Blastersquad Headband, Ashley Black's Kryopack™ Face Wrap, Ashley Black's Kryomat™ Small, MasterBlaster, Mini 2, FasciaBlaster® Nugget"
}

var discount_products_base_on_qty = {};
var us_checkout_only = {'deluxe-serum': true}
var doubled_products = {
  "replacement-extender-rings": 1
}
var bf_2022_sale = {
  'gift-bag': [
    {id: 39642277150816, name: 'Tissue Paper', price: 0.01}
  ],
  'masterblaster': [
    {id:39503703408736 , name: 'FasciaTabs', price: 0.01}
  ]
};
// var custom_variants_discount = {'39601898618976': 40, '39601898651744': 28.5714286, '39570680938592': 33.3333333}
var bundle_description = {};